exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-content[data-v-19203b0e] {\n  height: 100%;\n}\n.widget-content.transparent[data-v-19203b0e] {\n  background-color: transparent;\n}", ""]);

// exports
